import React,  { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { api } from '../../lib/api';
import { useAuthStore } from '../../stores/authStore';
import { LayoutDashboard, FileText, Bot, LogOut, Sun, Moon, Menu, X, ChevronRight, ChevronDown, Check, Building2, Settings, Bell, ArrowRightLeft, Users, ShieldCheck, Receipt, Truck } from 'lucide-react';
import { AlertTriangle as _AT } from 'lucide-react';
import { LayoutGrid, ShoppingCart, FileOutput, CreditCard, Settings2 } from 'lucide-react'; // [PATCH prodajni-tok v1] ikone prodajnega toka
import { PackageCheck } from 'lucide-react'; // [PATCH dobavnica-cmr-fe v1] ikona Dobavnice
import { BookText } from 'lucide-react'; // [PATCH prodaja-sifranti-meni v1] ikona Šifranti v Prodaji
import { PomocGumb } from '../pomoc/PomocGumb'; // [PATCH pomoc-fe v1] gumb Pomoč v glavi
import { FileInput } from 'lucide-react'; // [PATCH prodajni-tok v8] ikona Prejeti racuni (Placila obdrzijo Receipt)
import { CalendarDays, Route as IkonaPot } from 'lucide-react'; // [PATCH pn-dc-fe v1] [PATCH pn-nalog-fe v1] brez Calculator
import { usePnVloga } from '../../lib/pnVloga'; // [PATCH pn-23 v1]
const AlertTriangle = _AT;
import clsx from 'clsx';
import { UvozIndikator } from '../UvozIndikator';
import { ObvestilaZvonec } from '../ObvestilaZvonec'; // [PATCH obvestila-dokumenti v1]
import { PrijavaNapakeGumb } from '../PrijavaNapakeGumb'; // [PATCH napake-fe v1]
import { NapakeNavPostavka } from '../NapakeNavPostavka'; // [PATCH napake-fe v2]
import { ObvestilaNavPostavka } from '../ObvestilaNavPostavka'; // [PATCH objave-fe v1]
import { OpombeNavPostavka } from '../opombe/OpombeNavPostavka'; // [PATCH opombe-stranka-fe v1]
import { deloSledilec } from '../../lib/deloSledilec'; // [PATCH pregled-dela v2]
import { NazajGumb } from '../NazajGumb'; // [PATCH nastavitve-zavihki v1]
import { OpalUkazModal } from '../opal/OpalUkazModal'; // [PATCH opal-onboarding-E v1]
import { VascoUkazModal } from '../vasco/VascoUkazModal';   // [PATCH vasco-sync-fe v1]
import { useAplikacija, useMojeAplikacije } from '../../hooks/useAplikacija'; // [PATCH aplikacije-fe v2] locitev aplikacij // [PATCH aplikacije-fe v4] + pravice
import { slikaAplikacije } from '../../aplikacije'; // [PATCH aplikacije-fe v2]
import { shraniAplikacijo as _f0Shrani } from '../../aplikacije'; // [PATCH f0-aplikacije-poti v1b]

/* [PATCH ozadje-po-sekciji v1] ozadje vsebine v odtenku ploscice z nadzorne plosce.
   Razredi so preneseni 1:1 iz DashboardPage.tsx (menuStyle[*].card, vrstice 16-53);
   vzamemo samo bg par, rob ploscice na drsnem ovoju ni ozadje. Kljuc = zacetek poti. */
const OZADJE_POTI: Record<string, string> = {
  '/profil': 'bg-violet-50 dark:bg-violet-500/15',
  '/sifranti': 'bg-amber-50 dark:bg-amber-500/15',
  '/dnevnik': 'bg-teal-50 dark:bg-teal-500/15',
  '/insolventnost': 'bg-rose-50 dark:bg-rose-500/15',
  '/eposta': 'bg-cyan-50 dark:bg-cyan-500/15',
  '/edavki': 'bg-emerald-50 dark:bg-emerald-500/15',
  '/nastavitve': 'bg-sky-50 dark:bg-sky-500/15',
  // [PATCH opal-k8 v1] ista barva kot ploscica na nadzorni plosci
  '/sinhronizacija': 'bg-indigo-50 dark:bg-indigo-500/15',
};

const nav = [
  { to: '/podjetja', icon: Building2, label: 'Moja podjetja' },
  { to: '/nadzorna', icon: LayoutDashboard, label: 'Nadzorna plošča', end: true }, // [PATCH aplikacije-fe v1] prej '/'
  { to: '/dokumenti', icon: FileText, label: 'Dokumenti' },
  { to: '/prenosi', icon: ArrowRightLeft, label: 'Prenosi' },
  { to: '/agenti', icon: Bot, label: 'AI Agenti', badge: 'Novo' },
];
// [PATCH prodajni-tok v1] meni aplikacije Prodaja v dveh skupinah (NACRT prodajni tok v2 §1). 'kmalu' = siv, neklikljiv.
// jeAktiven: aktivnost po ?pogled= (NavLink gleda samo pathname).
const _pogled = (l: any) => new URLSearchParams(l.search || '').get('pogled');
const NAV_PRODAJA: any[] = [
  { skupina: 'PRODAJNI TOK', to: '/prodaja-pregled', icon: LayoutGrid, label: 'Pregled', end: true }, /* [PATCH prodaja-pregled-fe v1] prej '#kmalu-pregled', kmalu */
  { skupina: 'PRODAJNI TOK', to: '/dokumenti?tip=izdani_racun&pogled=ponudbe', icon: FileText, label: 'Ponudbe / predračuni', // [PATCH izdaja-prodajni-dok-ui v1]
    jeAktiven: (l: any) => l.pathname === '/dokumenti' && _pogled(l) === 'ponudbe' },
  { skupina: 'PRODAJNI TOK', to: '/dokumenti?tip=izdani_racun&pogled=narocila', icon: ShoppingCart, label: 'Naročila kupcev', // [PATCH izdaja-prodajni-dok-ui v1]
    jeAktiven: (l: any) => l.pathname === '/dokumenti' && _pogled(l) === 'narocila' },
  { skupina: 'PRODAJNI TOK', to: '/dokumenti?tip=izdani_racun&pogled=dobavnice', icon: PackageCheck, label: 'Dobavnice', // [PATCH dobavnica-cmr-fe v1]
    jeAktiven: (l: any) => l.pathname === '/dokumenti' && _pogled(l) === 'dobavnice' },
  { skupina: 'PRODAJNI TOK', to: '/dokumenti?tip=izdani_racun&pogled=cmr', icon: Truck, label: 'CMR', samoCmr: true, // [PATCH dobavnica-cmr-fe v1] samo ob vklopu v nastavitvah
    jeAktiven: (l: any) => l.pathname === '/dokumenti' && _pogled(l) === 'cmr' },
  { skupina: 'PRODAJNI TOK', to: '/dokumenti?tip=izdani_racun&pogled=rocni', icon: FileOutput, label: 'Izdani računi',
    jeAktiven: (l: any) => l.pathname === '/dokumenti' && _pogled(l) === 'rocni' },
  { skupina: 'PRODAJNI TOK', to: '#kmalu-placila', icon: CreditCard, label: 'Plačila', kmalu: true }, /* [PATCH prodaja-meni-nastavitve v1] zaenkrat skrita (filter v izrisu) */
  { skupina: 'NASTAVITVE', to: '/sifranti', icon: BookText, label: 'Šifranti', jeAktiven: (l: any) => l.pathname === '/sifranti' }, /* [PATCH prodaja-sifranti-meni v1] [PATCH prodaja-meni-nastavitve v1] skupina NASTAVITVE */
  { skupina: 'NASTAVITVE', to: '/nastavitve', icon: Settings, label: 'Nastavitve', jeAktiven: (l: any) => l.pathname === '/nastavitve' }, /* [PATCH prodaja-meni-nastavitve v1] stranka vidi samo Ročni vnos računa + Dobavnica / CMR */
  { skupina: 'RAČUNOVODSTVO', to: '/dokumenti?tip=izdani_racun', icon: Settings2, label: 'Računovodska obdelava',
    jeAktiven: (l: any) => l.pathname === '/dokumenti' && ['rocni', 'ponudbe', 'narocila', 'dobavnice', 'cmr'].indexOf(_pogled(l) || '') < 0 }, // [PATCH dobavnica-cmr-fe v1] prej samo !== 'rocni'
  { skupina: 'RAČUNOVODSTVO', to: '/prenosi', icon: ArrowRightLeft, label: 'Prenos' },
];
// [PATCH pregled-poslovanja-fe v1] meni aplikacije Pregled poslovanja
const NAV_PREGLED: any[] = [
  { to: '/pregled', icon: LayoutDashboard, label: 'Pregled poslovanja', end: true },
];
// [PATCH nabava-pregled-fe v1] »Pregled« na vrhu menija aplikacije Nabava
const NAV_NABAVA_PREGLED: any[] = [
  { to: '/nabava-pregled', icon: LayoutGrid, label: 'Pregled', end: true },
];
// [PATCH pn-dc-fe v1] meni aplikacij Delovni čas / Potni nalogi ('kmalu' = siv); stran /kadri ima zavihke ?tab=
const _tab = (l: any) => new URLSearchParams(l.search || '').get('tab');
/* [PATCH pn-19a v1] meni: glavni del + OSTALO (Namen poti za vse, Nastavitve samo admin — stranka brez zastavice nima /kadri) */
const _kadriZap = (l: any) => l.pathname === '/kadri' && _tab(l) !== 'nastavitve';
const _kadriNast = (l: any) => l.pathname === '/kadri' && _tab(l) === 'nastavitve';
const NAV_DELOVNI_CAS: any[] = [
  { skupina: 'DELOVNI ČAS', to: '/moj-mesec', icon: CalendarDays, label: 'Moj mesec' }, /* [PATCH dc2 v1] */
  { skupina: 'DELOVNI ČAS', to: '/dc-pregled', icon: LayoutGrid, label: 'Pregled dela' }, /* [PATCH dc-pregled v1] samo admin */
  { skupina: 'DELOVNI ČAS', to: '/dc-skupina', icon: LayoutGrid, label: 'Skupinski pregled dela' }, /* [PATCH dc-skupina-fe v1] samo admin DČ in >= 2 izbrani bazi */
  { skupina: 'NASTAVITVE', to: '/pn-sifranti?tab=zaposleni', icon: FileText, label: 'Šifranti', jeAktiven: (l: any) => l.pathname === '/pn-sifranti' }, /* [PATCH pn-22 v1] */
  { skupina: 'NASTAVITVE', to: '/kadri?tab=nastavitve', icon: Settings, label: 'Nastavitve', jeAktiven: _kadriNast }, /* [PATCH opomniki v1] Delovni čas: Nastavitve = samodejna opozorila */
];
const NAV_POTNI_NALOGI: any[] = [
  { skupina: 'POTNI NALOGI', to: '/potni-nalogi', icon: IkonaPot, label: 'Potni nalogi', jeAktiven: (l: any) => l.pathname.startsWith('/potni-nalogi') },
  { skupina: 'POTNI NALOGI', to: '/pn-prenos', icon: ArrowRightLeft, label: 'Prenos' }, /* [PATCH pn-prenos-kn21 v1] samo admin */
  { skupina: 'NASTAVITVE', to: '/pn-sifranti', icon: FileText, label: 'Šifranti', jeAktiven: (l: any) => l.pathname === '/pn-sifranti' }, /* [PATCH pn-22 v1] */
  { skupina: 'NASTAVITVE', to: '/kadri?tab=nastavitve', icon: Settings, label: 'Nastavitve', jeAktiven: _kadriNast },
];
// [PATCH izdaja-dokumenti v1] podmeni pod Dokumenti (tip = ?tip= v DokumentiPage)
const DOKUMENTI_PODMENI = [
  { tip: 'prejeti_racun', label: 'Prejeti računi', icon: Receipt },
  { tip: 'izdani_racun', label: 'Izdani računi', icon: FileText },
];

/* [PATCH banka-f1 v1b] meni aplikacije Banka (F1: izpiski + nastavitve; parjenje/prenos pridejo v F2–F4) */
const NAV_BANKA: any[] = [
  { to: '/banka', icon: FileText, label: 'Izpiski', end: true },
  { to: '/banka/pravila', icon: ArrowRightLeft, label: 'Pravila' }, // [PATCH banka-f2 v1b]
  { to: '/banka/prenos', icon: FileOutput, label: 'Prenos' }, // [PATCH banka-f4 v1]
  { to: '/banka/nastavitve', icon: Settings, label: 'Nastavitve' },
];

export function DashboardLayout() {
  const { logout, toggleTheme, theme, selectedCompany, setSelectedCompany } = useAuthStore();
  const vloga = useAuthStore((s: any) => s.role);
  const [jeSuperadmin, setJeSuperadmin] = useState(false);
  const [companies, setCompanies] = useState<any[]>([]);
  const [pickerOpen, setPickerOpen] = useState(false);
  // [PATCH glava-picker v1] iskalnik + abecedni vrstni red v izbirniku podjetij
  const [pickerIskanje, setPickerIskanje] = useState('');
  const brezSumnikov = (s: string) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const pickerPodjetja = [...companies]
    .sort((a: any, b: any) => (a.name || '').localeCompare(b.name || '', 'sl'))
    .filter((c: any) => {
      const q = brezSumnikov(pickerIskanje.trim());
      if (!q) return true;
      return brezSumnikov(c.name).includes(q) || brezSumnikov(String(c.tax_number || c.vat_number || '')).includes(q);
    });
  const [imaLogistiko, setImaLogistiko] = useState(false);
  useEffect(() => {
    if (selectedCompany) {
      api.get('/logistika/' + selectedCompany.id + '/aktiven')
        .then((r: any) => setImaLogistiko(r.data?.aktiven === true))
        .catch(() => setImaLogistiko(false));
    } else { setImaLogistiko(false); }
  }, [selectedCompany]);
  const naloziPodjetja = () => api.get('/companies/').then((r: any) => setCompanies(r.data)).catch(() => {});
  useEffect(() => {
    naloziPodjetja();
  }, []);
  useEffect(() => {
    api.get('/auth/me').then((r: any) => setJeSuperadmin(!!r.data.is_superadmin)).catch(() => {});
  }, []);
  const navExtra: any[] = [
    ...((vloga === 'admin' || jeSuperadmin) ? [{ to: '/upravljanje', icon: Users, label: 'Dostopi in pravice' }] : []), // [PATCH dostopi-pravice v1]
    ...(jeSuperadmin ? [{ to: '/superadmin', icon: ShieldCheck, label: 'Superadmin' }] : []),
  ];
  // [PATCH aplikacije-fe v2] meni po aktivni aplikaciji (NACRT locitev aplikacij v2 §5.3, D3-D5).
  // Prodaja: Izdani racuni, brez Placil; Nabava: Prejeti racuni + Placila. Logistika ostane pogojna po modulu podjetja.
  const { aplikacija, opis: aplOpis, smer: aplSmer } = useAplikacija();
  const { podatki: mojeApl } = useMojeAplikacije(); // [PATCH aplikacije-fe v4] upravlja_aplikacije za meni Uporabniki (stranka)
  const pnVloga = usePnVloga(); // [PATCH pn-23 v1] vloga v PN/DČ za izbrano podjetje (enako kot backend)
  const [dcSkupinaN, setDcSkupinaN] = useState(0); // [PATCH dc-skupina-fe v1] število izbranih baz za Skupinski pregled dela
  const _lokDc = useLocation();
  useEffect(() => {
    if (aplikacija !== 'delovni_cas') { setDcSkupinaN(0); return; }
    let ziv = true;
    const beri = () => { api.get('/dc-skupina/izbrane').then((r: any) => { if (ziv) setDcSkupinaN((r.data?.baze || []).length); }).catch(() => { if (ziv) setDcSkupinaN(0); }); };
    beri();
    window.addEventListener('dc-skupina-spremenjena', beri);
    return () => { ziv = false; window.removeEventListener('dc-skupina-spremenjena', beri); };
  }, [aplikacija, _lokDc.pathname]);
  const [cmrVklop, setCmrVklop] = useState(false); // [PATCH dobavnica-cmr-fe v1] CMR v meniju samo ob vklopu (nastavitve.cmr_vklopljen)
  useEffect(() => {
    const cid = selectedCompany?.id;
    if (aplikacija !== 'prodaja' || !cid) { setCmrVklop(false); return; }
    let ziv = true;
    const beri = () => { api.get(`/izdaja/${cid}/nastavitve`).then((r: any) => { if (ziv) setCmrVklop(!!r.data?.nastavitve?.cmr_vklopljen); }).catch(() => { if (ziv) setCmrVklop(false); }); };
    beri();
    window.addEventListener('izdaja-nastavitve-spremenjene', beri);
    return () => { ziv = false; window.removeEventListener('izdaja-nastavitve-spremenjene', beri); };
  }, [aplikacija, selectedCompany?.id]); // eslint-disable-line
  const navPlacila = { to: '/placila', icon: Receipt, label: 'Plačila' };
  const navDokumenti = aplSmer === 'izdani_racun'
    ? { to: '/dokumenti?tip=izdani_racun', icon: FileText, label: 'Izdani računi' }
    : { to: '/dokumenti?tip=prejeti_racun', icon: FileInput, label: 'Prejeti računi' }; /* [PATCH prodajni-tok v8] FileInput */
  const navOsnovni: any[] = (() => {
    const a: any[] = aplikacija === 'prodaja'
      ? [...NAV_PRODAJA] : aplikacija === 'pregled' ? [...NAV_PREGLED] /* [PATCH pregled-poslovanja-fe v1] */ : aplikacija === 'delovni_cas' ? [...NAV_DELOVNI_CAS] : aplikacija === 'potni_nalogi' ? [...NAV_POTNI_NALOGI] : aplikacija === 'banka' ? [...NAV_BANKA] /* [PATCH banka-f1 v1b] */ /* [PATCH pn-dc-fe v1] */ /* [PATCH prodajni-tok v1] */ /* [PATCH prodajni-tok v6] Moja podjetja + Nadzorna plosca sta na dnu (navDno) */
      : [
      ...(aplikacija === 'nabava' ? NAV_NABAVA_PREGLED : []), /* [PATCH nabava-pregled-fe v1] */
      navDokumenti,
      ...(aplikacija === 'nabava' ? [navPlacila] : []),
      ...nav.filter((n: any) => n.to === '/prenosi'),
    ];
    if (imaLogistiko) {
      a.push({ to: '/logistika', icon: Truck, label: 'Logistika' });
    }
    return a;
  })();
  // [PATCH prodajni-tok v8] sistemske poti (upravljanje) zivijo brez aplikacije: meni = Aplikacije + Uporabniki/Superadmin.
  // V aplikacijah Uporabniki/Superadmin NISO vec v meniju (dostop z vstopne strani, razdelek UPRAVLJANJE).
  const _lok = useLocation();
  const sistemskaPot = new RegExp('^/(uporabniki|superadmin|uporabniki-aplikacije|upravljanje)(/|$)').test(_lok.pathname); /* [PATCH pravice-p3 v1] */
  const navSistem: any[] = [
    { to: '/', icon: LayoutGrid, label: 'Aplikacije', end: true },
    ...(vloga === 'stranka'
      ? (mojeApl && mojeApl.upravlja_aplikacije ? [{ to: '/upravljanje', icon: Users, label: 'Dostopi in pravice' }] : []) /* [PATCH dostopi-pravice v1] */
      : navExtra),
  ];
  const navKoncni: any[] = sistemskaPot ? navSistem
    : vloga === 'stranka'
    ? (aplikacija === 'prodaja' ? NAV_PRODAJA.filter((n: any) => n.skupina !== 'RAČUNOVODSTVO') /* [PATCH prodajni-tok v1] stranka: samo prodajni tok (Q2) */
                                : aplikacija === 'pregled' ? [...NAV_PREGLED] /* [PATCH pregled-poslovanja-fe v1] */ : aplikacija === 'delovni_cas' ? (pnVloga === 'admin' ? [...NAV_DELOVNI_CAS] : NAV_DELOVNI_CAS.filter((n: any) => !String(n.to).startsWith('/kadri') && !String(n.to).startsWith('/pn-sifranti') && !String(n.to).startsWith('/dc-pregled') /* [PATCH dc-popravki v1] zaposleni v DČ brez Šifrantov */)) : aplikacija === 'potni_nalogi' ? (pnVloga === 'admin' ? [...NAV_POTNI_NALOGI] : NAV_POTNI_NALOGI.filter((n: any) => !String(n.to).startsWith('/kadri') && !String(n.to).startsWith('/pn-prenos') /* [PATCH pn-prenos-kn21 v1] */)) /* [PATCH pn-dc-fe v1] [PATCH pn-nalog-15 v1] zaposleni brez menija Zaposleni in nastavitve */ : aplikacija === 'banka' ? [...NAV_BANKA] /* [PATCH banka-f1 v1b] stranka = racunovodja (B4) */ : [...(aplikacija === 'nabava' ? NAV_NABAVA_PREGLED : []) /* [PATCH nabava-pregled-fe v1] */, navDokumenti, ...(aplikacija === 'nabava' ? [navPlacila] : [])])
    : [...navOsnovni];
  const navigate = useNavigate();
  // [PATCH dc-skupina-fe v1] Skupinski pregled dela: samo admin DČ in >= 2 izbrani bazi
  for (let _i = navKoncni.length - 1; _i >= 0; _i--) if (navKoncni[_i]?.to === '/dc-skupina' && !(dcSkupinaN >= 2 && (vloga !== 'stranka' || pnVloga === 'admin'))) navKoncni.splice(_i, 1);
  for (let _i = navKoncni.length - 1; _i >= 0; _i--) if (navKoncni[_i]?.samoCmr && !cmrVklop) navKoncni.splice(_i, 1); // [PATCH dobavnica-cmr-fe v1]

  /* [PATCH f0-aplikacije-poti v1b] varovalo na zaslonu: aplikacija POTI, ki je uporabnik v izbranem podjetju nima -> izbira aplikacije */
  const _f0Loc = useLocation();
  const { selectedCompany: _f0Podj } = useAuthStore();
  useEffect(() => {
    if (!mojeApl || mojeApl.superadmin || !_f0Podj) return;
    const pot = _f0Loc.pathname;
    const tip = new URLSearchParams(_f0Loc.search).get('tip') || '';
    let app: string | null = null;
    if (pot === '/dokumenti') {
      if (tip.startsWith('izdani')) app = 'prodaja';
      else if (['prejeti_racun', 'credit_note', 'avans', 'storno_avansa'].includes(tip)) app = 'nabava';
    }
    else if (pot === '/placila' || pot === '/nabava-pregled') app = 'nabava';
    else if (pot === '/prodaja-pregled' || pot.startsWith('/izdaja')) app = 'prodaja';
    else if (pot === '/pregled') app = 'pregled';
    else if (pot === '/pn-sifranti') app = (aplikacija === 'delovni_cas' ? 'delovni_cas' : 'potni_nalogi'); // [PATCH dc-sifranti-app v1] skupna pot PN/DČ — iz DČ ostane v DČ
    else if (pot.startsWith('/potni-nalogi') || ['/pn-prenos', '/vozila', '/nameni-poti'].includes(pot)) app = 'potni_nalogi';
    else if (pot.startsWith('/banka')) app = 'banka'; // [PATCH banka-f1 v1b]
    else if (pot === '/moj-mesec' || pot === '/dc-pregled' || pot === '/dc-skupina') app = 'delovni_cas'; // [PATCH dc-skupina-fe v1]
    if (!app) return;
    const dovP = mojeApl.podjetja_po_aplikaciji?.[app];
    if (!dovP) return;
    if (!dovP.includes(String(_f0Podj.id))) { navigate('/', { replace: true }); return; }
    if (app !== aplikacija) _f0Shrani(app as any);
  }, [mojeApl, _f0Podj, _f0Loc.pathname, _f0Loc.search, aplikacija]); // odvisnosti namenoma izrecne
  const location = useLocation();
  useEffect(() => {
    // [PATCH aplikacije-fe v2] straznik: brez izbrane aplikacije -> izbira aplikacije (prej: stranka na '/' -> /dokumenti)
    if (!aplikacija && !sistemskaPot) navigate('/', { replace: true }); /* [PATCH prodajni-tok v8] sistemske poti brez aplikacije */
  }, [aplikacija, navigate, sistemskaPot]);
  /* [PATCH nazaj-pravilo v1] poti levega menija: tam gumb Nazaj ni potreben (meni je navigacija) */
  const POTI_MENIJA = ['/podjetja','/dokumenti','/prenosi','/agenti','/uporabniki','/superadmin','/placila','/logistika','/napake','/obvestila','/izdaja'/* [PATCH izdaja-dokumenti v1] strani izdaje imajo svoj gumb nazaj */,'/nadzorna'/* [PATCH aplikacije-fe v1] */,'/uporabniki-aplikacije'/* [PATCH aplikacije-fe v4] */,'/pregled'/* [PATCH pregled-poslovanja-fe v1] */,'/prodaja-pregled'/* [PATCH prodaja-pregled-fe v1] */,'/nabava-pregled'/* [PATCH nabava-pregled-fe v1] */,'/kadri'/* [PATCH pn-dc-fe v1] */,'/potni-nalogi'/* [PATCH pn-nalog-fe v1] */,'/nameni-poti'/* [PATCH pn-nalog-15b v1] */,'/vozila'/* [PATCH pn-vozila-19b v1] */,'/pn-sifranti'/* [PATCH pn-22 v1] */,'/moj-mesec'/* [PATCH dc2 v1] */,'/dc-pregled'/* [PATCH dc-pregled v1] */,'/dc-skupina'/* [PATCH dc-skupina-fe v1] */,'/pn-prenos'/* [PATCH pn-prenos-kn21 v1] */,'/upravljanje'/* [PATCH pravice-p3 v1] */, ...(aplikacija === 'prodaja' ? ['/sifranti', '/nastavitve'] : [])/* [PATCH prodaja-meni-nastavitve v1] *//* [PATCH prodaja-sifranti-meni v1] v Prodaji je Šifranti v meniju -> brez gumba nazaj */];
  const vMeniju = location.pathname === '/' || POTI_MENIJA.some((p) => location.pathname === p || location.pathname.startsWith(p + '/'));
  /* [PATCH ozadje-po-sekciji v1] prva ujemajoca pot; brez ujemanja ostane obstojece ozadje */
  const ozadjeSekcije = OZADJE_POTI[
    Object.keys(OZADJE_POTI).find((k) => location.pathname.startsWith(k)) || ''
  ];
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => { deloSledilec.ponastavi(); /* [PATCH pregled-dela v2] */ logout(); navigate('/prijava'); };

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-950 overflow-hidden">
      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-black/60 lg:hidden"
          onClick={() => setMobileOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={clsx(
        'fixed lg:relative z-50 h-full flex flex-col',
        'bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800',
        'transition-all duration-300',
        sidebarOpen ? 'w-64' : 'w-16',
        mobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      )}>
        {/* Logo */}
        <div className="flex items-center gap-3 px-4 py-5 border-b border-gray-200 dark:border-gray-800">
          <svg viewBox="-2 14 86 82" className="h-8 w-8 flex-shrink-0 text-gray-900 dark:text-white" aria-hidden="true">
            <polygon points="46.5,20.7 40.5,19 35.3,21.8 3.5,72.8 15.7,72.5 23.2,61.2 37.2,60.7 42.3,52.3 29.2,52.3 29,51.3 41.2,32 52.3,47.7 58.7,39.3" fill="currentColor" />
            <polygon points="39.8,72.5 49.3,72.8 59.3,58 60.3,57.7 70.5,72.8 80.2,72.8 61.8,44.7 59.8,44.7" fill="#2563EB" />
          </svg>
          {sidebarOpen && (
            <span className="font-bold text-2xl tracking-tight">
              <span className="text-gray-900 dark:text-white">Alfa</span><span className="text-blue-600">Berg</span>
            </span>
          )}
          <button onClick={() => setSidebarOpen(!sidebarOpen)}
            className="ml-auto p-1 rounded text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hidden lg:flex">
            <ChevronRight className={clsx('w-4 h-4 transition-transform', sidebarOpen && 'rotate-180')} />
          </button>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto flex flex-col">{/* [PATCH prodajni-tok v6] flex-col, da gre navDno na dno */}
          {navKoncni.filter((n:any)=>n.to!=='/agenti'/* [PATCH skrij-meni v1] */ && n.to!=='#kmalu-placila'/* [PATCH prodaja-meni-nastavitve v1] Plačila zaenkrat skrita */).map(({ to, icon: Icon, label, end, badge, skupina, kmalu, jeAktiven }: any, _i: number, _arr: any[]) => (
            <div key={to}>{/* [PATCH izdaja-dokumenti v1] ovoj: pod Dokumenti podmeni Prejeti/Izdani */}
            {/* [PATCH prodajni-tok v1] napis skupine pred prvim vnosom skupine */}
            {skupina && (_i === 0 || _arr[_i - 1].skupina !== skupina) && (
              sidebarOpen
                ? <div className={'mx-1 mb-1.5 ' + (_i === 0 ? 'mt-1' : 'mt-5 pt-4 border-t border-gray-200 dark:border-gray-800')}>{/* [PATCH prodajni-tok-meni-pregled v1] napis skupine v okvirčku, črta med skupinama */}
                    <div className="inline-flex items-center px-2.5 py-1 rounded-md bg-gray-100 dark:bg-gray-800 text-[11px] font-semibold tracking-wider text-gray-600 dark:text-gray-300">{skupina}</div>
                  </div>
                : <div className="my-3 border-t border-gray-200 dark:border-gray-800" />
            )}
            {kmalu ? (/* [PATCH prodajni-tok v1] siv, neklikljiv vnos */
              <div title="Kmalu na voljo" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-400 dark:text-gray-600 cursor-not-allowed select-none">
                <Icon className="w-5 h-5 flex-shrink-0" />
                {sidebarOpen && (<><span>{label}</span><span className="ml-auto text-[10px] px-1.5 py-0.5 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-400">Kmalu</span></>)}
              </div>
            ) : (
            <NavLink to={to} end={end}
              className={({ isActive }) => clsx(
                'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all',
                (jeAktiven ? jeAktiven(location) : isActive) /* [PATCH prodajni-tok v1] aktivnost po ?pogled= */
                  ? 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400'
                  : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white'
              )}>
              <Icon className="w-5 h-5 flex-shrink-0" />
              {sidebarOpen && (
                <>
                  <span>{label}</span>
                  {badge && (
                    <span className="ml-auto text-xs bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-300 px-1.5 py-0.5 rounded-full">
                      {badge}
                    </span>
                  )}
                </>
              )}
            </NavLink>
            )}{/* [PATCH prodajni-tok v1] konec kmalu ? : */}
            {to === '/dokumenti' && (
              <div className="mt-1 space-y-0.5">{/* [PATCH izdaja-dokumenti v1] podmeni Dokumenti */}
                {DOKUMENTI_PODMENI.map((p) => {
                  const akt = location.pathname === '/dokumenti' && (new URLSearchParams(location.search).get('tip') || 'prejeti_racun') === p.tip;
                  const PIcon = p.icon;
                  return (
                    <NavLink key={p.tip} to={`/dokumenti?tip=${p.tip}`} title={p.label}
                      className={clsx('flex items-center gap-3 rounded-lg text-sm transition-all', sidebarOpen ? 'pl-9 pr-3 py-1.5' : 'px-3 py-1.5 justify-center',
                        akt ? 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400 font-medium' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white')}>
                      <PIcon className="w-4 h-4 flex-shrink-0" />
                      {sidebarOpen && <span>{p.label}</span>}
                    </NavLink>
                  );
                })}
              </div>
            )}
            </div>
          ))}
          {vloga !== 'stranka' && !sistemskaPot && (/* [PATCH prodajni-tok v8b] ne na sistemskih poteh */
            <NapakeNavPostavka sidebarOpen={sidebarOpen} />
          )}{/* [PATCH stranka-skrij-napake v1] ZACASNO skrito; backend prijav ne omejuje */}
            <OpombeNavPostavka sidebarOpen={sidebarOpen} />{/* [PATCH opombe-stranka-fe v1b] stranka: Za urediti + okno ob vstopu */}
          {vloga !== 'stranka' && !sistemskaPot && (/* [PATCH prodajni-tok v8b] */
            <ObvestilaNavPostavka sidebarOpen={sidebarOpen} />
          )}{/* [PATCH stranka-skrij-obvestila v1] razvojne objave niso za vlogo stranka */}
          {vloga !== 'stranka' && !sistemskaPot && (/* [PATCH prodajni-tok v6] Moja podjetja + Nadzorna plosca na dnu navigacije, nad crto */ /* [PATCH prodajni-tok v8] ne na sistemskih poteh */
            <div className="pt-3 border-t border-gray-200 dark:border-gray-800 space-y-1" style={{ marginTop: 'auto' }}>{/* [PATCH prodajni-tok v6b] space-y-1 na nav prepise mt-auto */}
              {nav.filter((n: any) => n.to === '/podjetja' || n.to === '/nadzorna').map(({ to, icon: Icon, label, end }: any) => (
                <NavLink key={to} to={to} end={end}
                  className={({ isActive }) => clsx('flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all',
                    isActive ? 'bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white')}>
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  {sidebarOpen && <span>{label}</span>}
                </NavLink>
              ))}
            </div>
          )}
        </nav>

        {/* Bottom */}
        <div className="px-2 py-4 border-t border-gray-200 dark:border-gray-800 space-y-1">
          <button onClick={toggleTheme}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all">
            {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            {sidebarOpen && <span>{theme === 'dark' ? 'Svetla tema' : 'Temna tema'}</span>}
          </button>
          <button onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950 transition-all">
            <LogOut className="w-5 h-5" />
            {sidebarOpen && <span>Odjava</span>}
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Topbar */}
        <header className="h-12 flex items-center gap-4 px-4 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">{/* [PATCH naziv-prikaz v3] */}{/* [PATCH glava-kompakt v1] h-14 -> h-12 */}{/* [PATCH prodajni-tok v7] gap-4/px-4: vec prostora po locitvi aplikacij */}
          <button onClick={() => setMobileOpen(true)} className="lg:hidden">
            <Menu className="w-5 h-5 text-gray-500" />
          </button>
          {/* [PATCH aplikacije-fe v2] znacka aktivne aplikacije; klik = menjava aplikacije, podjetje ostane (Q9) */}
          {sistemskaPot && (/* [PATCH prodajni-tok v8b] na sistemskih poteh nevtralna znacka */
            <button onClick={() => navigate('/')} title="Nazaj na aplikacije"
              className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-semibold shrink-0 bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200 hover:opacity-80 transition">
              <LayoutGrid className="w-4 h-4" /><span>Upravljanje</span>
            </button>
          )}
          {aplOpis && !sistemskaPot && (
            <button onClick={() => navigate('/?izbira=1')} title="Zamenjaj aplikacijo"
              className={clsx('flex items-center gap-2 pl-1.5 pr-3 py-1.5 rounded-lg text-sm font-semibold shrink-0 transition hover:opacity-80', aplOpis.znacka)}>{/* [PATCH prodajni-tok v7] vecja znacka */}
              <img src={slikaAplikacije(aplOpis.id)} alt="" className="w-7 h-7 rounded-md" draggable={false} />
              <span>{aplOpis.naziv}</span>
            </button>
          )}
          <div className="relative w-[360px] shrink-0">{/* [PATCH naziv-prikaz v3] */}{/* [PATCH prodajni-tok v7] 360 px, ena vrstica */}
            <button onClick={() => { setPickerOpen((o) => !o); setPickerIskanje(''); }} /* [PATCH glava-picker v1] reset iskanja */
              className="flex items-center gap-2 w-full min-w-0 text-sm font-medium text-gray-700 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-400 transition"
              title="Izberi / zamenjaj podjetje">
              <Building2 className="w-4 h-4 text-blue-500" />
              {/* [PATCH naziv-prikaz v3] 30 znakov (v2: 60) v dveh vrsticah (line clamp 2); polni naziv v title */}
              <span className="min-w-0 text-left text-sm truncate" title={selectedCompany ? selectedCompany.name : ''}>{selectedCompany ? (selectedCompany.short_name || selectedCompany.name) : 'Ni izbranega podjetja'}</span>{/* [PATCH prodajni-tok v7] ena vrstica, text-sm, brez reza na 30 znakov */}
              <ChevronDown className={clsx('w-4 h-4 text-gray-400 transition-transform', pickerOpen && 'rotate-180')} />
            </button>
            {pickerOpen && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setPickerOpen(false)} />
                <div className="absolute left-0 top-9 z-50 w-80 max-h-96 overflow-y-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg">
                  {/* [PATCH glava-picker v1] iskalnik na vrhu */}
                  <div className="sticky top-0 z-10 bg-white dark:bg-gray-900 p-2 border-b border-gray-100 dark:border-gray-800">
                    <input autoFocus value={pickerIskanje} onChange={(e) => setPickerIskanje(e.target.value)}
                      placeholder="Išči podjetje …"
                      className="w-full px-3 py-1.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white focus:outline-none focus:border-blue-400" />
                  </div>
                  {companies.length === 0 && (
                    <div className="px-4 py-3 text-sm text-gray-400">Ni podjetij</div>
                  )}
                  {companies.length > 0 && pickerPodjetja.length === 0 && (
                    <div className="px-4 py-3 text-sm text-gray-400">Ni zadetkov</div>
                  )}
                  {pickerPodjetja.map((c: any) => (
                    <button key={c.id} onClick={() => { setSelectedCompany(c); setPickerOpen(false); }}
                      className={clsx(
                        'w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800 border-b border-gray-100 dark:border-gray-800 last:border-0 flex items-center justify-between',
                        selectedCompany?.id === c.id && 'bg-blue-50 dark:bg-blue-950'
                      )}>
                      <div>
                        <div className="font-medium text-sm text-gray-900 dark:text-white">{c.name}</div>
                        <div className="text-xs text-gray-400"><span className="font-mono">{c.tax_number || c.vat_number || ''}</span>{c.servis ? <span> · {c.servis}</span> : null}</div>{/* [PATCH superadmin-upravljanje v1] */}
                      </div>
                      {selectedCompany?.id === c.id && <Check className="w-4 h-4 text-blue-500 shrink-0 ml-2" />}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
          {/* [PATCH zgornja-reza v1] reza: strani (npr. Dokumenti) vanjo vrinejo zavihke prek createPortal */}
          <div id="zgornja-reza" className="flex-1 min-w-0 flex items-center" />
          <div className="ml-auto flex items-center gap-2">
            <UvozIndikator/>
            {/* [PATCH banka-f5h v1] ISL Online — oddaljena pomoč, za vse uporabnike, novo okno */}
            <a href="https://www.islonline.com/si/sl/join/" target="_blank" rel="noopener noreferrer" title="ISL Online — oddaljena pomoč"
               className="px-2.5 py-1 rounded-lg border border-gray-300 dark:border-gray-700 text-xs font-semibold tracking-wide text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:border-blue-400">ISL</a>
            <PomocGumb/>{/* [PATCH pomoc-fe v1] samo na straneh z vsebino pomoči */}
            <ObvestilaZvonec/>{/* [PATCH obvestila-dokumenti v1] */}
            {vloga !== 'stranka' && (
              <PrijavaNapakeGumb/>
            )}{/* [PATCH napake-fe v1] */}{/* [PATCH stranka-skrij-trikotnik v1] ZACASNO skrito; pravice v napake.py nedotaknjene */}
            {/* [PATCH moj-racun v1] zobnik -> Moj racun; hardkodiran 'J' avatar ODSTRANJEN */}
            <button onClick={() => navigate('/moj-racun')} title="Moj račun"
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-500 dark:text-gray-400">
              <Settings className="w-5 h-5" />
            </button>
          </div>
        </header>

        {/* Content */}
        <main className={clsx('flex-1 overflow-y-auto px-3 py-2 transition-colors', ozadjeSekcije)}>{/* [PATCH ozadje-po-sekciji v1] */}{/* [PATCH naziv-prikaz v3] rob vsebine p-6 -> px-3 py-2 (vse strani) */}
          {/* [PATCH nastavitve-zavihki v1] bela lista poti odstranjena — skupni
              gumb na vseh straneh znotraj layouta razen nadzorne plosce.
              (prej: ['/profil','/sifranti','/dnevnik','/insolventnost','/moj-racun','/napake']) */}
          {/* [PATCH nazaj-pravilo v1] prej: pathname !== '/' ; zdaj samo strani izven levega menija */}
          {/* [PATCH mojracun-brez-nazaj v3] na strani Moj racun brez gumba Nazaj */}{!vMeniju && location.pathname !== '/moj-racun' && (
            <div className="mb-4"><NazajGumb /></div>
          )}
          <Outlet />
          {vloga !== 'stranka' && <OpalUkazModal />}{/* [PATCH opal-onboarding-E v1] obvestilo o koncanem Opal onboardingu */}
          {vloga !== 'stranka' && <VascoUkazModal />}{/* [PATCH vasco-sync-fe v1] */}
        </main>
      </div>

    </div>
  );
}
